import { render } from "./SendButton.vue?vue&type=template&id=1e6dcf74&scoped=true&ts=true"
import script from "./SendButton.vue?vue&type=script&lang=ts"
export * from "./SendButton.vue?vue&type=script&lang=ts"

import "./SendButton.vue?vue&type=style&index=0&id=1e6dcf74&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6dcf74"]])

export default __exports__